import React from "react";
import {
  Toolbar,
  SaveButton,
  Link,
  Button,
  Create,
  SimpleForm,
  AutocompleteInput,
  // DeleteButton,
  DateField,
  ReferenceField,
  List,
  Datagrid,
  FunctionField,
  Pagination,
  CardActions,
  Query,
  required,
  EditButton
} from "react-admin";
import { sortBy, path } from "ramda";
import { parse } from "query-string";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

import styled from "styled-components";

const validateForm = values => {
  const errors = {};
  if (!values.guide_id) {
    errors.guide_id = ["Guide is required"];
  }
  return errors;
};

const StyledDiv = styled.div(props => ({
  flexDirection: "column",
  alignItems: props.align ? props.align : "center",
  justifyContent: props.justify ? props.justify : "center",
  backgroundColor: props.color,
  paddingTop: props.padding ? props.padding : "0px",
  paddingBottom: props.padding ? props.padding : "0px",
  minHeight: "40px",
  display: "flex",
  minWidth: "100px"
}));

const TourGpsDevicePagination = props => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
);

const cardActionStyle = {
  zIndex: 2,
  display: "inline-block",
  float: "right"
};

const CustomEditTourButton = ({ record = {} }) => {
  return (
    <EditButton
      to={{
        pathname: `/tours/${record.id}/7`
      }}
      target="_blank"
      record={record}
      label="Edit Tour"
    />
  );
};

const ShowActions = ({ basePath, data, resource }) => (
  <CardActions style={cardActionStyle}></CardActions>
);

const TourGpsDeviceCreateToolbar = props => (
  <Toolbar {...props}>
    <SaveButton />
    <CancelButton object={props.record} />
  </Toolbar>
);

const GpsData = ({ tourId }) => {
  return (
    <Query
      type="GET_LIST"
      resource="gps_devices"
      const
      payload={{
        pagination: { page: 1, perPage: 1000 },
        filter: { tour_id: tourId, availability: true },
        sort: { field: "name", order: "ASC" }
      }}
    >
      {({ data, total, loading, error }) => {
        if (loading) {
          return <p>Loading...</p>;
        }
        if (error) {
          return <p>ERROR</p>;
        }
        return (
          <AutocompleteInput
            label="Gps Device"
            choices={data}
            validate={required()}
            optionText="model"
            optionValue="item_id"
            source="gps_device_id"
          />
        );
      }}
    </Query>
  );
};

const CreateTourGpsDeviceTitle = () => <span>Add tour gps device</span>;

const CancelButton = record => (
  <Button
    component={Link}
    to={{
      pathname: `/tours/${record.object.tour_id}/7`
    }}
    label="Cancel"
  >
    <ArrowBackIcon />
  </Button>
);

export const TourGpsDeviceCreate = props => {
  const tour_id = parse(props.location.search).tour_id;
  const redirect = tour_id ? `/tours/${tour_id}/7` : "edit";

  return (
    <Create title={<CreateTourGpsDeviceTitle />} {...props}>
      <SimpleForm
        toolbar={<TourGpsDeviceCreateToolbar />}
        redirect={redirect}
        validate={validateForm}
      >
        <GpsData tourId={tour_id} />
      </SimpleForm>
    </Create>
  );
};

export const TourGpsDeviceList = props => {
  return (
    <List
      {...props}
      perPage={25}
      resource="tour_gps_devices"
      pagination={<TourGpsDevicePagination />}
      bulkActionButtons={false}
      filter={{ fromTour: true }}
      actions={<ShowActions />}
    >
      <Datagrid>
        <FunctionField
          sortable={false}
          label="Tour"
          render={tour => {
            return `${tour.tour_name.tour_name_en}`;
          }}
        />
        <DateField
          label="Start Date"
          source="tour_start_date"
          sortable={false}
        />
        <DateField label="End Date" source="tour_end_date" sortable={false} />

        <FunctionField
          sortable={false}
          label="Guides"
          render={tour => {
            return (
              <StyledDiv align="end" padding="10px">
                {sortBy(
                  path(["gps_device", "model"]),
                  tour.tour_gps_devices
                ).map(tdevice => {
                  return <span>{path(["gps_device", "model"], tdevice)}</span>;
                })}
              </StyledDiv>
            );
          }}
        />

        <ReferenceField
          source="location_id_1"
          reference="locations"
          linkType={false}
          sortable={false}
          label="Base"
        >
          <FunctionField
            sortable={false}
            addLabel={false}
            render={location => {
              return (
                <StyledDiv color={location.color}>
                  {location.location_name}
                </StyledDiv>
              );
            }}
          />
        </ReferenceField>
        <ReferenceField
          sortable={false}
          source="location_id_2"
          reference="locations"
          linkType={false}
          label="Destination"
        >
          <FunctionField
            sortable={false}
            addLabel={false}
            render={location => {
              return (
                <StyledDiv color={location.color}>
                  {location.location_name}
                </StyledDiv>
              );
            }}
          />
        </ReferenceField>
        {/* <DeleteButton /> */}
        <CustomEditTourButton />
      </Datagrid>
    </List>
  );
};



// WEBPACK FOOTER //
// ./src/resources/tourGpsDevices.js